<template>
    <v-dialog v-model="show" persistent no-click-animation width="600">
        <v-card style="border-radius: 5px !important;">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('setting') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <v-tabs v-model="currentTab" style="min-height: 598px !important;" slider-color="#FFFFFF">
                <v-tab ripple>NLP</v-tab>
                <v-tab ripple>Fallback</v-tab>
                <v-tab ripple>{{ $f.tc('scenario') }}</v-tab>
                <v-tab ripple>{{ $f.tc('globalSetting') }}</v-tab>
                <v-tab ripple>KB</v-tab>
                <v-tab ripple>{{ $f.tc('globalLua') }}</v-tab>
                <v-tabs-items touchless>
                    <!--Tab NLP-->
                    <v-tab-item>
                        <ScenarioNLPTab @updateScenario="updateScenario"
                                        @close="close"></ScenarioNLPTab>
                    </v-tab-item>

                    <!--Tab Fallback-->
                    <v-tab-item>
                        <div class="dialog-content fci-scrollbar">
                            <!--Falllback-->
                            <div class="label mt-0">Fallback</div>
                            <v-select
                                hide-details outlined
                                v-model="fallback"
                                :items="fallbackList"
                                class="input-custom"
                                :readonly="!isEdit"
                            ></v-select>

                            <!--Prompt-->
                            <div class="label">Prompt</div>
                            <v-textarea
                                hide-details
                                v-model="fallback_prompt"
                                :readonly="!isEdit"
                                class="textarea-custom"
                            ></v-textarea>
                            <div v-if="fallback === FallbackType.SUPPORTER">
                                <div class="label">{{ $f.tc('phone') }}</div>
                                <v-text-field
                                    hide-details
                                    v-model="fallback_phone"
                                    class="input-custom"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </div>
                        </div>
                        <div class="dialog-footer" v-if="isEdit">
                            <div class="btn-custom mr-0"
                                 @click="saveScenarioSetting">{{ $f.tc('save') }}
                            </div>
                        </div>
                    </v-tab-item>

                    <!--Tab Scenario-->
                    <v-tab-item
                        class="fci-scrollbar p-12"
                        style="overflow-y: auto"
                        :style="{height: `${isEdit ? 'calc(80vh - 101px)' : 'calc(80vh - 150px)'}`}"
                    >
                        <!--Portal-->
                        <div style="display: flex; align-items: center;">
                            <div class="label mb-0 mt-0 mr-12">{{ $f.tc('portal') }}</div>
                            <v-switch v-model="portal" :readonly="!isEdit" color="#0052cc"
                                      @change="savePortal"></v-switch>
                        </div>

                        <!--Cache lua-->
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div>
                                <div class="label mb-0 mt-0">Cache lua</div>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <div class="label mb-0 mt-0 mr-12">Overwrite prompt cache</div>
                                <v-switch
                                    v-model="overrideLua" :readonly="!isEdit" color="#0052cc"
                                    @change="saveOverrideLua"></v-switch>
                                <div v-if="isEdit">
                                    <v-btn
                                        icon
                                        small
                                        class="mx-0 my-1"
                                        @click="saveCacheLua"
                                        v-if="isEditCacheLua"
                                    >
                                        <img src="/img/scenario/save.svg" alt="icon-save"
                                             style="transform: scale(1.15)">
                                    </v-btn>
                                    <v-btn
                                        icon
                                        small
                                        class="mx-0 my-1"
                                        @click="isEditCacheLua = true"
                                        v-else
                                    >
                                        <img src="/img/edit-blue.svg" alt="icon-edit" style="transform: scale(1.1)">
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                        <LuaEditor
                            :item.sync="cacheLua"
                            :editable="isEditCacheLua"
                        ></LuaEditor>

                        <!--Buttons for action-->
                        <div class="label mt-12">{{ $f.tc('scenario') }}</div>
                        <div style="display: flex; align-items: center">
                            <div class="btn-custom" @click="goToAutomationTest">{{ $f.tc('automationTest') }}</div>
                            <div class="btn-custom" @click="exportData">{{ $f.tc('export') }}</div>
                            <div class="btn-custom" @click="showDialogImportData" v-if="isEdit">{{
                                    $f.tc('import')
                                }}
                            </div>
                            <div class="btn-custom" @click="showDialogSaveBackup" v-if="isEdit">
                                {{ $f.tc('save') + ' ' + $t('scenarioBackup') }}
                            </div>
                        </div>

                        <!--Recent backup scenarios-->
                        <div class="label mt-12">{{ $f.tc('recentBackupScenarios') }}</div>
                        <table class="backup-table">
                            <thead>
                            <tr>
                                <th class="text-center">
                                    {{ $f.tc('version') }}
                                </th>
                                <th class="text-left">
                                    {{ $f.tc('createBy') }}
                                </th>
                                <th class="text-left">
                                    {{ $f.tc('createdDate') }}
                                </th>
                                <th class="text-center">
                                    {{ $f.tc('action') }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="(item, index) in backups"
                                :key="`scenario_${index}_${item['created_time']}`"
                            >
                                <td>
                                    <div class="centerXY">
                                        <div style="font-family: 'open sans semi', serif; margin-right: 4px">
                                            v.{{ item.version }}
                                        </div>
                                        <v-tooltip right>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on" color="#617CA5" size="20">mdi-information</v-icon>
                                            </template>
                                            <div style="max-width: 300px">
                                                {{ item.description }}
                                            </div>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td class="text-left" style="color: #0052CC; cursor: default" :title="item.user.email">
                                    {{ item.user.email ? item.user.email.split("@")[0] : 'empty' }}
                                </td>
                                <td class="text-left">
                                    {{ $f.formatDateTimeLocal(item['created_time'], 'HH:mm DD-MM-YYYY') }}
                                </td>
                                <td class="text-center">
                                    <div class="centerXY">
                                        <div class="btn-icon mr-1" @click="downloadBackup(item)"
                                             :title="$f.tc('downloadBackup')">
                                            <img src="/img/scenario/download_blue.svg" alt="icon-download-backup"
                                                 style="transform: scale(1.1)">
                                        </div>
                                        <div v-if="isEdit" class="btn-icon mr-1" @click="restoreBackup(item)"
                                             :title="$f.tc('restoreBackup')">
                                            <v-icon color="#0052CC" size="22">mdi-backup-restore</v-icon>
                                        </div>
                                        <div v-if="isEdit" class="btn-icon" @click="deleteBackup(item)"
                                             :title="$f.tc('deleteBackup')">
                                            <img src="/img/delete-new_red.svg" alt="icon-delete-backup">
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="backups.length === 0 && isLoadingRecentBackup">
                                <td colspan="4" class="no-data">
                                    <div class="display-flex align-center justify-center">
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                            class="mr-8"
                                            style="width: 20px"
                                        ></v-progress-circular>
                                        {{ $f.tc('loadingData') }}
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="backups.length === 0 && !isLoadingRecentBackup">
                                <td colspan="4" class="text-center no-data">
                                    {{ $f.tc('noDataAvailable') }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </v-tab-item>

                    <!--Tab Global Setting-->
                    <v-tab-item>
                        <div class="ScenarioGlobalSetting">
                            <div class="dialog-content fci-scrollbar" ref="TabGlobalSetting">
                                <table>
                                    <thead>
                                    <tr>
                                        <th>{{ $f.tc('setting') }}</th>
                                        <th>{{ $f.tc('value') }}</th>
                                        <th v-if="isEdit"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <!--Current global setting-->
                                    <tr v-for="(item, i) in itemList" :key="i">
                                        <td>
                                            <v-text-field
                                                outlined hide-details
                                                v-model="item.setting_name"
                                                class="input-custom"
                                                style="width: 100%"
                                                :readonly="!isEdit"
                                            ></v-text-field>
                                        </td>
                                        <td>
                                            <v-text-field
                                                outlined hide-details
                                                v-model="item.value"
                                                class="input-custom"
                                                style="width: 100%"
                                                :readonly="!isEdit"
                                            ></v-text-field>
                                        </td>
                                        <td v-if="isEdit">
                                            <v-btn icon class="mx-0" @click.stop="deleteItem(i)">
                                                <img src="/img/delete-blue.svg" alt="icon-delete"
                                                     style="transform: scale(1.3); padding-left: 1px">
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <!--New setting-->
                                    <tr v-if="isEdit">
                                        <td>
                                            <v-text-field
                                                outlined hide-details
                                                v-model="settingName"
                                                class="input-custom"
                                                @keypress.enter="addGlobalSetting"
                                                :placeholder="$f.tc('enterName')"
                                                style="width: 100%"
                                                ref="NewKeyGlobalSetting"
                                            ></v-text-field>
                                        </td>
                                        <td>
                                            <v-text-field
                                                outlined hide-details
                                                v-model="settingValue"
                                                class="input-custom"
                                                @keypress.enter="addGlobalSetting"
                                                :placeholder="$f.tc('enterDefaultValue')"
                                                style="width: 100%"
                                            ></v-text-field>
                                        </td>
                                        <td>
                                            <v-btn icon class="mx-0" @click.stop="addGlobalSetting">
                                                <img src="/img/add-blue.svg" alt="icon-delete"
                                                     style="transform: scale(1.4);">
                                            </v-btn>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!--Footer dialog-->
                            <div class="dialog-footer" v-if="isEdit">
                                <div class="btn-custom"
                                     @click="saveGlobalSettings">{{ $f.tc('save') }}
                                </div>
                                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
                            </div>
                        </div>
                    </v-tab-item>

                    <!--Tab KB-->
                    <v-tab-item>
                        <div class="dialog-content fci-scrollbar px-12 py-12" ref="TabNLP">
                            <div class="label mt-0">Endpoint</div>
                            <v-text-field
                                hide-details outlined
                                v-model="kbSetting.endpoint"
                                class="input-custom"
                                :readonly="!isEdit"
                            ></v-text-field>
                            <div class="centerY mt-12">
                                <div style="flex: 1; margin-right: 8px">
                                    <div class="label mt-0">Token</div>
                                    <v-text-field
                                        hide-details outlined
                                        v-model="kbSetting.token"
                                        class="input-custom"
                                        :readonly="!isEdit"
                                    ></v-text-field>
                                </div>
                                <div style="flex: 1">
                                    <div class="label mt-0">Project ID</div>
                                    <v-text-field
                                        hide-details outlined
                                        v-model="kbSetting.project_id"
                                        class="input-custom"
                                        :readonly="!isEdit"
                                    ></v-text-field>
                                </div>
                            </div>
                            <div class="centerY mt-12">
                                <div style="flex: 1; margin-right: 8px">
                                    <div class="label mt-0">NLP Label</div>
                                    <v-autocomplete
                                        hide-details outlined
                                        :items="nlpConfigs"
                                        item-text="label"
                                        item-value="label"
                                        v-model="kbSetting.nlp_label"
                                        class="input-custom"
                                        @input="isShowCurrentNLP = false"
                                        :readonly="!isEdit"
                                    ></v-autocomplete>
                                </div>
                                <div style="flex: 1;">
                                    <div class="label mt-0">No Intent Key</div>
                                    <v-text-field
                                        hide-details outlined
                                        v-model="kbSetting.no_intent_key"
                                        class="input-custom"
                                        :readonly="!isEdit"
                                    ></v-text-field>
                                </div>
                            </div>
                            <div class="label">Mapping rules</div>
                            <div v-for="(rule, index) in kbSetting.mapping_rules" :key="index"
                                 class="item-rule display-flex"
                                 :style="index === kbSetting.mapping_rules.length - 1 ? {borderBottom: '1px solid #96add0', marginBottom: '8px'} : ''"
                            >
                                <!--Input-->
                                <div style="border-right: 1px dashed #d9d9d9; width: 283px" class="p-10">
                                    <div class="label mt-0">Input Intent</div>
                                    <v-text-field
                                        hide-details outlined
                                        v-model="kbSetting.mapping_rules[index].input_intent"
                                        class="input-custom"
                                        :readonly="!isEdit"
                                    ></v-text-field>
                                    <!-- Conditions -->
                                    <div class="label">Conditions</div>
                                    <div style="display: flex; flex-wrap: wrap; gap: 6px">
                                        <div
                                            v-for="(condition, idx) in kbSetting.mapping_rules[index].conditions"
                                            :key="`conditions_${idx}`"
                                            class="chip-custom"
                                        >
                                            <span>{{ condition.type }}</span>
                                            <span class="px-1" style="font-weight: 700">{{ condition.op }}</span>
                                            <span>"{{ condition.value }}"</span>
                                            <v-icon v-if="isEdit" size="17" color="#000"
                                                    style="cursor: pointer; margin-left: 5px"
                                                    @click="deleteItemKB('conditions', index, idx)">
                                                mdi-close
                                            </v-icon>
                                        </div>
                                        <div
                                            v-if="isEdit"
                                            class="chip-custom btn-chip-add p-0" style="position: relative"
                                        >
                                            <div class="centerY" style="padding: 2px 8px; cursor: pointer"
                                                 @click="toggleItemKBCreator('conditions', index)">
                                                {{ $f.tc('addNew') }}
                                            </div>
                                            <div
                                                class="card-add-new p-0"
                                                style="left: -1px;"
                                                v-if="kbSetting.mapping_rules[index].show_conditions_creator"
                                            >
                                                <div class="centerY" style="padding: 8px">
                                                    <div style="width: 100px">
                                                        <v-text-field
                                                            hide-details outlined
                                                            v-model="newCondition.type"
                                                            class="input-custom"
                                                            placeholder="Entity"
                                                        ></v-text-field>
                                                    </div>
                                                    <div style="padding: 0 6px; width: 75px;">
                                                        <v-select
                                                            hide-details outlined
                                                            :items="OperatorList"
                                                            item-text="text"
                                                            item-value="value"
                                                            v-model="newCondition.op"
                                                            class="input-custom"
                                                            style="z-index: 300"
                                                        ></v-select>
                                                    </div>
                                                    <div style="width: 180px">
                                                        <v-text-field
                                                            hide-details outlined
                                                            v-model="newCondition.value"
                                                            class="input-custom"
                                                            placeholder="Values, separated by ;"
                                                        ></v-text-field>
                                                    </div>
                                                </div>
                                                <div style="padding: 8px; border-top: 1px solid #d9d9d9"
                                                     class="centerY justify-end">
                                                    <div class="btn-custom mr-6"
                                                         @click.stop="createNewItemKB('conditions', index)">
                                                        {{ $f.tc('save') }}
                                                    </div>
                                                    <div class="btn-outline"
                                                         @click.stop="kbSetting.mapping_rules[index].show_conditions_creator = false">
                                                        {{ $f.tc('cancel') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="no-data">
                                            {{
                                                kbSetting.mapping_rules[index].conditions.length === 0 ? $f.tc('noDataAvailable') : ''
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <!--Output-->
                                <div class="p-10" style="flex: 1">
                                    <div class="label mt-0">Output Intent</div>
                                    <v-autocomplete
                                        hide-details outlined
                                        :items="kbSetting.meta_data.intents"
                                        item-text="name"
                                        item-value="name"
                                        v-model="kbSetting.mapping_rules[index].output_intent"
                                        class="input-custom"
                                    ></v-autocomplete>
                                    <div class="label">Output Entities</div>
                                    <div style="display: flex; flex-wrap: wrap; gap: 6px">
                                        <div
                                            v-for="(entity, idx) in kbSetting.mapping_rules[index].output_entities"
                                            :key="`output_entities_${idx}`"
                                            class="chip-custom"
                                        >
                                            <span>entity:{{ entity.entity }}</span>;
                                            <span>value:{{ entity.value }}</span>
                                            <v-icon v-if="isEdit" size="17" color="#000"
                                                    style="cursor: pointer; margin-left: 5px"
                                                    @click="deleteItemKB('output_entities', index, idx)">
                                                mdi-close
                                            </v-icon>
                                        </div>
                                        <div
                                            v-if="isEdit"
                                            class="chip-custom btn-chip-add p-0" style="position: relative"
                                        >
                                            <div class="centerY" style="padding: 2px 8px; cursor: pointer"
                                                 @click="toggleItemKBCreator('output_entities', index)">
                                                {{ $f.tc('addNew') }}
                                            </div>
                                            <div
                                                class="card-add-new p-0"
                                                style="right: -1px;"
                                                v-if="kbSetting.mapping_rules[index].show_output_entities_creator"
                                            >
                                                <div class="centerY" style="padding: 8px">
                                                    <div style="width: 160px">
                                                        <v-autocomplete
                                                            hide-details outlined
                                                            :items="kbSetting.meta_data.entity_types"
                                                            item-text="name"
                                                            item-value="name"
                                                            v-model="newOutputEntity.entity"
                                                            class="input-custom"
                                                            placeholder="Entity"
                                                            style="z-index: 300"
                                                        ></v-autocomplete>
                                                    </div>
                                                    <div style="padding: 0 6px;">=</div>
                                                    <div style="width: 160px">
                                                        <v-text-field
                                                            hide-details outlined
                                                            v-model="newOutputEntity.value"
                                                            class="input-custom"
                                                            placeholder="Value"
                                                        ></v-text-field>
                                                    </div>
                                                </div>
                                                <div style="padding: 8px; border-top: 1px solid #d9d9d9"
                                                     class="centerY justify-end">
                                                    <div class="btn-custom mr-6"
                                                         @click.stop="createNewItemKB('output_entities', index)">
                                                        {{ $f.tc('save') }}
                                                    </div>
                                                    <div class="btn-outline"
                                                         @click.stop="kbSetting.mapping_rules[index].show_output_entities_creator = false">
                                                        {{ $f.tc('cancel') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="no-data">
                                            {{
                                                kbSetting.mapping_rules[index].output_entities.length === 0 ? $f.tc('noDataAvailable') : ''
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <!--Button delete mapping rule-->
                                <div class="btn-del-rule" @click="deleteMappingRule(index)">
                                    <img src="/img/delete-new.svg" alt="btn-del-mapping-rule" style="width: 16px">
                                </div>
                            </div>
                            <div class="centerY justify-start" v-if="isEdit">
                                <div class="btn-outline" @click="addMappingRule">
                                    <img src="/img/add-blue.svg" alt="icon-add-mapping-rule"
                                         style="transform: scale(1.2); margin-right: 8px">
                                    {{ $f.tc('addNew') }}
                                </div>
                            </div>
                            <div v-else class="no-data">
                                {{ kbSetting.mapping_rules.length === 0 ? $f.tc('noDataAvailable') : '' }}
                            </div>
                        </div>
                        <div class="dialog-footer justify-space-between" v-if="isEdit">
                            <div class="btn-outline ml-0"
                                 @click="updateKbMetadata"> {{ $f.tc('updateKbMetadata') }}
                            </div>
                            <div class="btn-custom mr-0" v-if="!loadingSaveKb"
                                 @click="saveKBSetting">{{ $f.tc('save') }}
                            </div>
                            <div v-else class="btn-disable mr-0">
                                {{ $f.tc('save') }}
                            </div>
                        </div>
                    </v-tab-item>

                    <!--Tab Global Lua-->
                    <v-tab-item>
                        <div>
                            <div v-if="isEdit"
                                 class="centerY justify-start p-12"
                                 style="border-bottom: 1px solid #b3d4fc">
                                <div class="btn-outline" @click="addConfig">
                                    <img src="/img/add-blue.svg" alt="icon-add-global-lua"
                                         style="margin-right: 6px; transform: scale(1.1) ">
                                    {{ $f.tc('addNew') }}
                                </div>
                            </div>
                            <div class="dialog-content fci-scrollbar" style="padding-top: 0 !important;"
                                 ref="TabGlobalLua">
                                <template v-for="(card, cardIndex) in globalLuaList">
                                    <ScenarioCard
                                        :key="cardIndex"
                                        :name.sync="card.label"
                                        :delete-able="isEdit"
                                        :move-able="isEdit"
                                        :name-editable="isEdit"
                                        @delete="deleteCard(cardIndex)"
                                        @moveUp="moveCardUp(cardIndex)"
                                        @moveDown="moveCardDown(cardIndex)"
                                        @updateCardName="newName => updateCardLabel(newName, cardIndex)"
                                        :name-invalid="['']"
                                        style="margin: 0 !important"
                                    >
                                        <LuaEditor
                                            :item.sync="card.lua_code"
                                            ref="card"
                                            :editable="isEdit"
                                        ></LuaEditor>
                                    </ScenarioCard>
                                </template>
                            </div>
                        </div>
                        <!--Footer dialog-->
                        <div class="dialog-footer" v-if="isEdit">
                            <div class="btn-custom"
                                 @click="saveGlobalLua">{{ $f.tc('save') }}
                            </div>
                            <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-card>
        <ScenarioBackupEditor ref="ScenarioBackupEditor"></ScenarioBackupEditor>
    </v-dialog>
</template>

<script>
import ScenarioService from "@/services/scenario.service";
import {mapState} from "vuex";
import CampaignService from "@/services/campaign.service";
import {ScenarioEventBus, ScenarioEventBusType} from "@/views/Scenario/scenario.eventbus";
import LuaEditor from "@/views/Scenario/NodeEditor/common/LuaEditor";
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";
import lodash from "lodash";
import store from "@/store/store";
import ScenarioBackupEditor from "@/views/Scenario/ScenarioBackupEditor";
import FormMixin from "@/modules/fptai/mixins/FormMixin.vue";
import ScenarioCard from "@/views/Scenario/components/ScenarioCard.vue";
import ScenarioNLPTab from "@/views/Scenario/ScenarioNLPTab.vue";

const FallbackType = {
    END: 'END',
    SUPPORTER: 'SUPPORTER'
}

const UserRole = {
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    EDITOR: 'EDITOR',
    TESTER: 'TESTER'
}

const LuaCardDefault = {
    label: 'LUA',
    lua_code: {script: ''}
}


const newConditionDefault = {
    type: '',
    op: '=',
    value: ''
}

const newOutputEntityDefault = {
    entity: '',
    value: ''
}

export default {
    name: "ScenarioSetting",
    components: {ScenarioNLPTab, ScenarioCard, ScenarioBackupEditor, LuaEditor},
    mixins: [DialogPromiseMixin, FormMixin],
    data() {
        return {
            OperatorList: [
                {text: '=', value: '='},
                {text: '!=', value: '!='},
                {text: 'in', value: 'IN'},
                {text: '!in', value: 'NOT_IN'},
            ],
            currentTab: 0,
            confidence: 70,
            portal: false,
            nlpCode: '',
            nlpName: '',
            fallback_prompt: '',
            fallback_phone: '',
            fallback: '',
            fallbackList: [
                {
                    text: 'end call',
                    value: FallbackType.END
                },
                {
                    text: 'switch to supporter',
                    value: FallbackType.SUPPORTER
                }
            ],
            cacheLua: {
                script: ''
            },
            configSetting: null,
            isEditCacheLua: false,
            FallbackType,
            // nlp configs
            enableNLPConfig: false,
            nlpConfigs: [],
            isShowCurrentNLP: true,
            settingName: '',
            settingValue: '',
            settingErrorMessage: '',
            // recent backup scenarios
            backups: [],
            isLoadingRecentBackup: false,
            // tab kb
            showWarningInfo: true,
            newRequiredEntity: '',
            newCondition: this.$utils.cloneObject(newConditionDefault),
            newOutputEntity: this.$utils.cloneObject(newOutputEntityDefault),
            kbSetting: {
                endpoint: '',
                project_id: '',
                token: '',
                nlp_label: '',
                no_intent_key: '',
                mapping_rules: [],
                meta_data: {
                    intents: [],
                    entity_types: [],
                    intents_entity_types: []

                }
            },
            creatorOn: {
                index: -1,
                name: ''
            },
            loadingSaveKb: false,
            overrideLua: false,
        }
    },
    created() {
        this.getKbSetting()
    },
    computed: {
        ...mapState({
            treeData: state => state.scenario.treeData,
            scenario: state => state.scenario.scenario,
            scenarioSetting: state => state.scenario.scenario_setting,
            globalSettings: state => state.scenario.globalSettingList,
            nlpList: state => state.campaign.bots ? state.campaign.bots.map(item => ({
                text: item.name,
                value: item.code,
                source: item
            })) : [],
            useGuardrail: state => state.scenario.useGuardrail,
            globalLua: state => state.scenario.globalLua
        }),
        isEdit() {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        itemList() {
            return lodash.orderBy(this.$utils.cloneObject(this.globalSettings), 'created_time')
        },
        originalItemMap() {
            let map = {}
            for (let item of this.globalSettings) {
                map[item.setting_name] = item
            }
            return map
        },
        globalLuaList() {
            return lodash.orderBy(this.$utils.cloneObject(this.globalLua), 'card_index')
        },
        originalGlobalLuaMap() {
            let map = {}
            for (let item of this.globalLua) {
                map[item.id] = item
            }
            return map
        },
    },
    destroyed() {
        this.$store.commit(this.$actionTypes.scenario.GLOBAL_SETTING, [])
        this.$store.commit(this.$actionTypes.scenario.GLOBAL_LUA, [])
    },
    methods: {
        getKbSetting() {
            ScenarioService.KbSettingService.search(this.$route.params.scenarioId).then(
                result => {
                    if (result.data[0]) {
                        this.kbSetting = result.data[0]
                        if (!result.data[0]['meta_data']['intents']) {
                            this.kbSetting.meta_data.intents = []
                        }
                        if (!result.data[0]['meta_data']['entity_types']) {
                            this.kbSetting.meta_data.entity_types = []
                        }
                    }
                    // save to store
                    this.$store.commit(this.$actionTypes.scenario.KB_SETTING, result.data)
                }
            )
        },
        getBackups() {
            this.isLoadingRecentBackup = true
            ScenarioService.ScenarioBackupService.search(this.$route.params.scenarioId).then(result => {
                this.isLoadingRecentBackup = false
                this.backups = result.data.sort((a, b) => {
                    return new Date(b['created_time']).getTime() - new Date(a['created_time']).getTime()
                })
            })
        },
        saveScenarioSetting() {
            let model = {
                fallback: {
                    type: this.fallback,
                    content: {
                        prompt: this.fallback_prompt,
                        phone_number: this.fallback_phone
                    }
                }
            }
            this.updateScenario(model)
        },
        savePortal() {
            let model = {
                use_portal: this.portal
            }
            this.updateScenario(model, false)
        },
        saveOverrideLua() {
            let model = {
                override_lua: this.overrideLua
            }
            this.updateScenario(model, false)
        },
        saveCacheLua() {
            if (this.scenarioSetting) {
                ScenarioService.SettingService.update(this.$route.params.scenarioId, this.scenarioSetting.id, {
                    'lua_code': this.cacheLua.script
                }).then(result => {
                    this.$store.dispatch(this.$actionTypes.scenario.SCENARIO_SETTING, result.data)
                    this.isEditCacheLua = false
                    this.$appService.toastSuccess(this.$f.tc('save') + ' ' + 'cache lua' + ' ' + this.$t('success'))
                })
            } else {
                this.$appService.toastError(this.$f.tc('canNotGetScenarioSetting'))
            }
        },
        updateScenario(model, isClosed = true) {
            this.$appService.showLoading()
            ScenarioService.CRUD.update(
                this.$store.state.scenario.scenario.id,
                model
            ).then(
                result => {
                    this.$store.dispatch(this.$actionTypes.scenario.SCENARIO, result.data)
                    this.promise.resolve()
                    this.$appService.toastSuccess(this.$f.tc('saveSettingSuccess'))
                    if (isClosed) {
                        this.close()
                    }
                },
                this.$appService.handleRequestError
            ).finally(this.$appService.hideLoading)
        },
        updateValue() {
            if (this.scenario) {
                this.confidence = this.scenario.intent_confidence
                this.portal = this.scenario.use_portal
                this.overrideLua = this.scenario.override_lua
                this.nlpCode = this.scenario.nlp ? this.scenario.nlp.code : ''
                this.nlpName = this.scenario.nlp ? this.scenario.nlp.name : ''
                this.fallback = this.scenario.fallback.type
                if (this.scenario.fallback.content) {
                    this.fallback_prompt = this.scenario.fallback.content.prompt
                    this.fallback_phone = this.scenario.fallback.content.phone_number
                } else {
                    this.fallback_prompt = ''
                    this.fallback_phone = ''
                }
            }
            this.$store.commit(this.$actionTypes.scenario.GLOBAL_SETTING, [])
            this.$store.commit(this.$actionTypes.scenario.GLOBAL_LUA, [])
        },
        open() {
            if (this.globalSettings.length === 0) {
                this.loadGlobalSetting()
            }
            this.getBackups()
            this.getGlobalLua()

            this.isShowCurrentNLP = true
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        close() {
            this.show = false
            this.$emit('close')
            this.updateValue()
        },
        // actions for tab NLP
        // functions for tab scenario
        exportData() {
            ScenarioService.exportScenario()
        },
        showDialogImportData() {
            ScenarioEventBus.$emit(ScenarioEventBusType.IMPORT_FILE, {
                resolve: data => {
                    let file = data.file
                    if (file.type !== 'application/json') {
                        this.$appService.toastError('file invalid, accept json only')
                        return
                    }
                    let formData = new FormData()
                    formData.append('file', file)
                    formData.append('isOverwriteNLPConfigs', data.isOverwriteNLPConfigs ? 1 : 0)
                    this.importData(formData)
                }
            })
        },
        importData(formData) {
            let scenarioId = this.$route.params.scenarioId
            this.$appService.showLoading()
            ScenarioService.importScenario(this.$route.params.scenarioId, formData).then(
                result => {
                    this.close()
                    this.promise.resolve(result.data)
                    this.$appService.toastSuccess(this.$f.tc('importBotSuccess'))
                    this.$store.dispatch(this.$actionTypes.scenario.GET_TREE_DATA)
                    this.$store.dispatch(this.$actionTypes.scenario.GET_GLOBAL_SETTING, scenarioId)
                    this.$store.dispatch(this.$actionTypes.scenario.GET_DICTIONARY_TTS, scenarioId)
                    this.$store.dispatch(this.$actionTypes.scenario.GET_VARIABLE, scenarioId)
                    this.$store.dispatch(this.$actionTypes.scenario.GET_LLM_CONFIGS, scenarioId)
                    this.$store.dispatch(this.$actionTypes.scenario.GET_GLOBAL_LUA, scenarioId)
                }
            ).finally(this.$appService.hideLoading)
        },
        showDialogSaveBackup() {
            this.$refs.ScenarioBackupEditor.open().then(model => {
                this.saveScenarioBackup(model.description)
            })
        },
        saveScenarioBackup(desBackup) {
            let state = store.state.scenario
            let scenario = state.scenario
            let treeData = state.treeData
            let globalLua = state.globalLua
            globalLua.forEach((item, index) => {
                item.card_index = index
            })
            globalLua.forEach(item => {
                item.lua_code = item.lua_code.script
            })
            let dataBackup = {
                scenario: {
                    nodes: treeData.nodeList,
                    start_node_id: treeData.startId,
                    variables: state.variableList,
                    dictionaries_tts: state.dictionaryTtsList,
                    fallback: scenario.fallback,
                    scenario_setting: state.scenario_setting,
                    global_setting: state.globalSettingList,
                    llm_config: state.llmConfigs,
                    global_lua: globalLua,
                }
            }
            this.$appService.showLoading()
            ScenarioService.ScenarioBackupService.create(this.$route.params.scenarioId, {
                json_backup: JSON.stringify(dataBackup),
                description: desBackup
            }).then(() => {
                this.close()
                this.$appService.toastSuccess(`${this.$f.tc('save')} ${this.$t('scenarioBackup')} ${this.$t('success')}`)
            }).finally(this.$appService.hideLoading)
        },
        goToAutomationTest() {
            this.$router.push('/scenarios/' + this.$route.params.scenarioId + '/testsets')
        },
        scrollBottom(nameRef) {
            this.$nextTick(() => {
                this.$refs[nameRef].scrollTo({
                    top: this.$refs[nameRef].scrollHeight,
                    behavior: 'smooth'
                })
            })
        },
        // global setting functions
        addGlobalSetting() {
            if (this.nameIsEmpty()) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('setting')}))
                return
            }
            if (this.nameIsExist()) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicate', {
                    key: this.$f.tc('setting'),
                    value: this.settingName
                }))
                return
            }
            this.itemList.push({
                setting_name: this.settingName,
                value: this.settingValue,
            })
            this.scrollBottom('TabGlobalSetting')
            this.clearNewSetting()
            this.$refs.NewKeyGlobalSetting.$el.focus()
        },
        clearNewSetting() {
            this.settingName = ''
            this.settingValue = ''
        },
        deleteItem(index) {
            this.itemList.splice(index, 1)
            this.$forceUpdate()
        },
        saveGlobalSettings() {
            let addList = []
            let updateList = []
            let deleteList = []
            for (let item of this.itemList) {
                item['setting_name'] = item['setting_name'].trim()
                item['value'] = item['value'].trim()
                let originalItem = this.originalItemMap[item.setting_name]
                if (originalItem) {
                    originalItem.doNotDelete = true
                    if (item.value !== originalItem.value) {
                        item.id = originalItem.id
                        updateList.push(item)
                    }
                } else {
                    addList.push(item)
                }
            }
            for (let i in this.originalItemMap) {
                let item = this.originalItemMap[i]
                if (!item.doNotDelete) {
                    deleteList.push(item)
                }
            }
            let promiseList = []
            let scenario_id = this.$route.params.scenarioId
            for (let item of addList) {
                promiseList.push(ScenarioService.GlobalSettingService.create(scenario_id, item))
            }
            for (let item of updateList) {
                promiseList.push(ScenarioService.GlobalSettingService.update(scenario_id, item.id, item))
            }
            for (let item of deleteList) {
                promiseList.push(ScenarioService.GlobalSettingService.delete(scenario_id, item.id))
            }

            let i18n = {
                action: this.$t('update'),
                item: this.$t('globalSetting')
            }
            Promise.allSettled(promiseList).then(
                resultList => {
                    this.$appService.hideLoading()
                    for (let result of resultList) {
                        if (result.status === 'rejected') {
                            this.$appService.toastError(this.$f.tc('actionFailed', i18n))
                            return
                        }
                    }
                    this.loadGlobalSetting()
                    this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                }
            )
        },
        nameIsEmpty() {
            return !this.settingName
        },
        nameIsExist() {
            let item = this.itemList.find(item => item.setting_name === this.settingName)
            return !!item
        },
        loadGlobalSetting() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_GLOBAL_SETTING, this.$route.params.scenarioId)
        },
        // methods for action backup table
        downloadBackup(item) {
            let jsonData = item['json_backup']
            if (!jsonData) {
                return
            }
            let data = JSON.parse(jsonData)
            this.$utils.downloadJSON(data, `${this.scenario.name}_backup_${item['created_time']}`)
        },
        restoreBackup(item) {
            let jsonData = item['json_backup']
            if (!jsonData) {
                this.$appService.toastError(this.$f.tc('canNotLoadBackupData'))
                return
            }
            this.$appService.confirm(this.$f.tc('confirmRestoreBackup', [`v.${item.version}`])).then(confirm => {
                if (confirm) {
                    const blob = new Blob([jsonData], {type: 'text/plain'})
                    let formData = new FormData()
                    formData.append("file", blob)
                    this.importData(formData)
                }
            })
        },
        deleteBackup(item) {
            this.$appService.confirm(this.$f.tc('confirmDelete', {item: `${this.$t('backup')} \"v.${item.version}\"`})).then(
                confirm => {
                    if (!confirm) {
                        return
                    }
                    this.$appService.showLoading()
                    ScenarioService.ScenarioBackupService.delete(this.$route.params.scenarioId, item.id).then(() => {
                        this.close()
                        this.$appService.toastSuccess(`${this.$t('deleteBackup')} ${this.$t('success')}`)
                    }).finally(this.$appService.hideLoading)
                }
            )

        },
        // functions for tab KB
        resetItemKBCreator(key) {
            switch (key) {
                case 'conditions':
                    this.newCondition = this.$utils.cloneObject(newConditionDefault)
                    break
                case 'output_entities':
                    this.newOutputEntity = this.$utils.cloneObject(newOutputEntityDefault)
                    break
            }
        },
        toggleItemKBCreator(itemKey, index) {
            this.resetItemKBCreator(itemKey)
            if (!itemKey) {
                return
            }
            // close old creator
            if (this.creatorOn.index > -1 && this.creatorOn.name) {
                this.kbSetting.mapping_rules[this.creatorOn.index][this.creatorOn.name] = false
            }
            const showKeyCreator = `show_${itemKey}_creator`
            this.creatorOn = {
                index: index,
                name: showKeyCreator
            }
            this.kbSetting.mapping_rules[index][showKeyCreator] = !this.kbSetting.mapping_rules[index][showKeyCreator]
        },
        createNewItemKB(itemKey, index) {
            const showKeyCreator = `show_${itemKey}_creator`
            switch (itemKey) {
                case 'conditions':
                    if (this.newCondition.type && this.newCondition.op) {
                        this.kbSetting.mapping_rules[index][itemKey].push(this.newCondition)
                        this.kbSetting.mapping_rules[index][showKeyCreator] = false
                    }
                    break
                case 'output_entities':
                    if (this.newOutputEntity.entity) {
                        this.kbSetting.mapping_rules[index][itemKey].push(this.newOutputEntity)
                        this.kbSetting.mapping_rules[index][showKeyCreator] = false
                    }
                    break
            }
        },
        deleteItemKB(itemKey, index, idx) {
            if (index > -1 && idx > -1) {
                this.kbSetting.mapping_rules[index][itemKey].splice(idx, 1)
            }
        },
        addMappingRule() {
            this.kbSetting.mapping_rules.push({
                show_conditions_creator: false,
                show_output_entities_creator: false,
                conditions: [],
                input_intent: "",
                output_entities: [],
                output_intent: "",
            })
        },
        deleteMappingRule(index) {
            if (index > -1) {
                this.kbSetting.mapping_rules.splice(index, 1)
            }
        },
        saveKBSetting() {
            this.creatorOn = {
                index: -1,
                name: ''
            }
            this.loadingSaveKb = true
            let model = this.$utils.cloneObject(this.kbSetting)
            if (model['id']) {
                ScenarioService.KbSettingService.update(this.$route.params.scenarioId, model['id'], model).then(
                    () => {
                        this.$appService.toastSuccess(`${this.$t('update')} ${this.$t('success')}`)
                    }
                ).finally(() => {
                    this.loadingSaveKb = false
                })
            } else {
                ScenarioService.KbSettingService.create(this.$route.params.scenarioId, model).then(
                    () => {
                        this.getKbSetting()
                        this.$appService.toastSuccess(`${this.$t('create')} ${this.$t('success')}`)
                    }
                ).finally(() => {
                    this.loadingSaveKb = false
                })
            }
        },
        updateKbMetadata() {
            let model = {
                'endpoint': this.kbSetting.endpoint
            }
            ScenarioService.getKbMetadata(this.$route.params.scenarioId, model).then(
                res => {
                    this.kbSetting.meta_data = res.data
                    this.$appService.toastSuccess(`${this.$t('update')} ${this.$t('success')}`)
                }
            ).catch(
                () => {
                    this.$appService.toastError(`${this.$t('update')} ${this.$t('failed')}`)
                }
            )
        },
        getGlobalLua() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_GLOBAL_LUA, this.$route.params.scenarioId)
        },
        saveGlobalLua() {
            let addList = []
            let updateList = []
            let deleteList = []
            this.globalLuaList.forEach((item, index) => {
                item.card_index = index
            })
            for (let item of this.globalLuaList) {
                let originalItem = this.originalGlobalLuaMap[item.id]
                if (originalItem) {
                    originalItem.doNotDelete = true
                    if (item.lua_code.script !== originalItem.lua_code.script ||
                        item.label !== originalItem.label ||
                        item.card_index !== originalItem.card_index) {
                        updateList.push(item)
                    }
                } else {
                    addList.push(item)
                }
            }
            for (let i in this.originalGlobalLuaMap) {
                let item = this.originalGlobalLuaMap[i]
                if (!item.doNotDelete) {
                    deleteList.push(item)
                }
            }
            let promiseList = []
            let scenario_id = this.$route.params.scenarioId

            addList.forEach(item => {
                item.lua_code = item.lua_code.script
            })
            updateList.forEach(item => {
                item.lua_code = item.lua_code.script
            })
            for (let item of addList) {
                promiseList.push(ScenarioService.GlobalLUAService.create(scenario_id, item))
            }
            for (let item of updateList) {
                promiseList.push(ScenarioService.GlobalLUAService.update(scenario_id, item.id, item))
            }
            for (let item of deleteList) {
                promiseList.push(ScenarioService.GlobalLUAService.delete(scenario_id, item.id))
            }

            let i18n = {
                action: this.$t('update'),
                item: this.$t('globalLua')
            }
            Promise.allSettled(promiseList).then(
                resultList => {
                    this.$appService.hideLoading()
                    for (let result of resultList) {
                        if (result.status === 'rejected') {
                            this.$appService.toastError(this.$f.tc('actionFailed', i18n))
                            return
                        }
                    }
                    this.getGlobalLua()
                    this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                }
            )
        },
        addConfig() {
            let temp = this.$utils.cloneObject(LuaCardDefault)
            this.globalLuaList.push(temp)
            this.$forceUpdate()
            this.scrollBottom('TabGlobalLua')
        },
        deleteCard(index) {
            this.globalLuaList.splice(index, 1)
            this.$nextTick().then(() => {
                this.$forceUpdate()
            })
        },
        moveCardUp(index) {
            this.moveCard(index, -1)
        },
        moveCardDown(index) {
            this.moveCard(index, 1)
        },
        updateCardLabel(newName, index) {
            this.globalLuaList[index].label = newName
        },
        moveCard(index, d) {
            if (this.globalLuaList[index + d]) {
                let temp = this.globalLuaList[index + d]
                this.globalLuaList[index + d] = this.globalLuaList[index]
                this.globalLuaList[index] = temp
            }
            this.$nextTick().then(() => {
                this.$forceUpdate()
            })
        }
    },
    watch: {
        scenario: {
            immediate: true,
            handler: function () {
                this.updateValue()
            }
        },
        scenarioSetting: {
            immediate: true,
            handler: function () {
                if (this.scenarioSetting) {
                    this.cacheLua.script = this.scenarioSetting['lua_code']
                    this.enableNLPConfig = this.scenarioSetting.version >= 2
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.btn-custom {
    margin-right: 8px;
}

.label {
    margin-top: 12px;
    margin-bottom: 2px;
    font-family: "open sans semi", serif;
    font-size: 13px;
}

.dialog-content {
    height: calc(80vh - 150px);
    overflow-y: auto;
}

.confidence {
    width: 85px;

    input {
        padding: 0 0 0 12px;
        height: 32px;
        line-height: 32px;
        outline: none;
        border-radius: 5px;
        border: 1px solid #D9D9D9;
        font-size: 14px;
        width: 85px;

        &.custom-focus:focus {
            outline: 2px solid #0052CC6B;
            border-color: #0052CC !important;
        }
    }
}

.btn-del-config {
    display: flex;
    align-items: center;

    &:hover {
        transition: 0.3s;
    }
}

.box-warning {
    padding: 6px 6px 6px 12px;
    color: #f27670;
    background: #ff8a8045;
    border-radius: 5px;
}

.textarea-custom, .input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            outline-offset: 0;
            font-size: 14px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            padding: 6px 12px;
        }
    }
}

.textarea-custom {
    ::v-deep {
        textarea {
            padding: 8px 12px !important;

            &::-webkit-scrollbar {
                width: 7px;
                height: 10px;
                background-color: transparent;
                border: none;
            }

            &::-webkit-scrollbar-track {
                background-color: transparent;
                border: none;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background: rgba(0, 0, 0, 0.1);
                border: none;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: rgba(0, 0, 0, 0.5);
            }
        }
    }
}

.item-rule {
    border: 1px solid #96add0;
    border-bottom: none;
    position: relative;
}

.chip-custom {
    background: #D9D9D9;
    border: 1px solid #D9D9D9;
    font-size: 13px;
    padding: 2px 6px 2px 8px;
    border-radius: 5px;
    display: flex;
    align-items: center;
}

.btn-chip-add {
    background: #0052CC;
    border: 1px solid #0052CC;
    color: #FFF;
    padding: 2px 8px;
    user-select: none;
}

.btn-del-rule {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    width: 26px;
    cursor: pointer;
    background: #ff8a8045;
}

.card-add-new {
    position: absolute;
    top: 26px;
    z-index: 99;
    color: #2c3e50;
    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;
    background: #FFF;
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #D9D9D9;
}

.no-data {
    color: #919191;
    font-size: 13px;
}

.other-nlp {
    width: 178px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px;
    font-family: "open sans", serif;
}

::v-deep {
    .CodeMirror {
        height: 250px !important;
    }

    .v-tabs__container {
        height: 48px !important;
        border-bottom: 1px solid #E4EDFA;
        padding: 0 12px;
    }

    .v-tabs__item {
        font-family: "open sans semi", serif;
        font-weight: 400 !important;
        height: 32px !important;
        line-height: 32px !important;
        min-width: 0 !important;
        border-radius: 5px;
        text-transform: none;
        font-size: 14px !important;
        padding: 0 12px !important;
        transition: 0.4s;

        &:not(.v-tabs__item--active):hover {
            background: #F2F2F2;
            color: #141927;
        }
    }

    .v-tabs__item--active {
        background: #EEF6FF !important;
        color: #0052CC !important;
    }

    .v-tabs__div {
        text-transform: none !important;
        font-weight: 400 !important;
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 0 !important;

        .v-messages {
            min-height: 2px !important;
        }
    }

    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input--slider {
        margin-top: 0 !important;
    }

    .v-slider__thumb {
        width: 18px !important;
        height: 18px !important;
        left: -9px !important;
    }

    .v-slider__thumb-label {
        border-radius: 50% 50% 0;
        transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);
    }

    .tab-nlp {
        .v-label {
            font-family: 'open sans', serif !important;
            font-size: 14px !important;
            color: #000;
        }

        .v-input--selection-controls {
            padding-top: 12px !important;
        }

        .v-input--selection-controls__ripple {
            height: 0;
            width: 0;
        }
    }

    .v-text-field__details {
        position: absolute;
        right: 6px;
        top: -18px;
    }

    .v-select {
        .v-input__slot {
            padding: 6px 4px 6px 12px !important;
        }
    }

    .input-custom:has(.error--text):not(.v-input--is-readonly), .textarea-custom:has(.error--text):not(.v-input--is-readonly) {
        .v-input__slot {
            border-color: #ff5252 !important;
        }
    }

    .input-custom.v-input--is-focused:not(.v-input--is-readonly), .textarea-custom.v-input--is-focused:not(.v-input--is-readonly) {
        .v-input__slot {
            outline: 2px solid #FF52526B;
        }

        &:not(.error--text) {
            .v-input__slot {
                outline: 2px solid #0052CC6B;
                border-color: #0052CC !important;
            }
        }
    }
}

.v-select.input-custom {
    ::v-deep .v-input__slot {
        padding: 6px 6px 6px 12px !important;
    }

    ::v-deep .v-icon {
        height: 8px;
    }
}

table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    tr {
        border-bottom: 1px solid #96add0;
    }

    tr {
        td {
            padding: 0 6px;

            &:first-child {
                padding-left: 12px;
            }
        }
    }
}

table.backup-table {
    th {
        padding: 0 6px !important;
    }

    tr td:first-child {
        padding-left: 6px !important;
    }
}

.ScenarioGlobalSetting {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        padding: 12px;
        height: calc(80vh - 150px);
        overflow-y: auto;
    }
}
</style>
